import React, { useContext, useEffect } from "react";
import { useFreshChatData } from "./store";
import moment from "moment";
import { CustomerProps } from "./ShowCustomer";

function FreshChat({ setMessageFloater }) {
  const { fetchFreshChatData, data } = useFreshChatData();
  const { caseId } = useContext(CustomerProps);

  useEffect(() => {
    fetchFreshChatData(caseId);
  }, [caseId]);

  useEffect(() => {
    setMessageFloater(true);
  }, [data]);

  return (
    <div
      style={{ height: "100%", overflowY: "scroll" }}
      className="scrollable-container"
    >
      {Array.isArray(data) &&
        data.map((chat, index) => (
          <div className="d-flex justify-content-end" key={index}>
            <div
              style={{ background: "#F6FFED", width: "75%" }}
              className="border rounded border-success p-2 m-2 shadow"
            >
              <div className="d-flex justify-content-between mb-4 mt-2 align-items-end">
                <p className="m-0 text-warning fw-bold">
                  {chat.chat_meta.actor && chat.chat_meta.actor.name}
                </p>
                <small className="text-black">
                  {moment(chat.updatedAt).format("MMM Do YYYY, h:mm a")}
                </small>
              </div>
              <p className="text-black fw-bold">{`${chat.chat_text}`}</p>
            </div>
          </div>
        ))}
    </div>
  );
}

export default FreshChat;
